<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 2a10 10 0 1010 10A10 10 0 0012 2zm0 18a8 8 0 118-8 8 8 0 01-8 8z"/><path d="M16.42 13a.5.5 0 00-.64.3 4 4 0 01-7.56 0 .49.49 0 00-.64-.3.5.5 0 00-.3.64 5 5 0 009.44 0 .5.5 0 00-.3-.64zM15 8.5a2.05 2.05 0 00-2 1.34.5.5 0 00.94.32 1.13 1.13 0 012.06 0 .49.49 0 00.47.34.45.45 0 00.16 0 .5.5 0 00.37-.66 2.05 2.05 0 00-2-1.34zM8 10.16a1.13 1.13 0 012.06 0 .49.49 0 00.47.34.45.45 0 00.16 0 .5.5 0 00.31-.66A2.05 2.05 0 009 8.5a2.05 2.05 0 00-2 1.34.5.5 0 10.94.32z"/></svg>